import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "area_title" }
const _hoisted_2 = { class: "area_button" }
const _hoisted_3 = {
  class: "area_body",
  style: {"margin-bottom":"10px"}
}
const _hoisted_4 = { class: "area_section flex ac" }
const _hoisted_5 = { class: "flex ac noPrint" }
const _hoisted_6 = { class: "flex ac" }
const _hoisted_7 = { class: "datepicker" }
const _hoisted_8 = { class: "datepicker" }
const _hoisted_9 = { class: "print_table onlyPrint" }
const _hoisted_10 = { class: "" }
const _hoisted_11 = { class: "left" }
const _hoisted_12 = ["textContent"]
const _hoisted_13 = { class: "" }
const _hoisted_14 = { class: "left" }
const _hoisted_15 = ["textContent"]
const _hoisted_16 = { class: "" }
const _hoisted_17 = { class: "left" }
const _hoisted_18 = { class: "flex jc" }
const _hoisted_19 = ["textContent"]
const _hoisted_20 = { class: "print_table" }
const _hoisted_21 = { class: "noPrint" }
const _hoisted_22 = {
  colspan: "7",
  class: "left"
}
const _hoisted_23 = ["textContent"]
const _hoisted_24 = { class: "noPrint" }
const _hoisted_25 = {
  colspan: "7",
  class: "left"
}
const _hoisted_26 = { class: "noPrint" }
const _hoisted_27 = {
  colspan: "7",
  class: "left"
}
const _hoisted_28 = {
  colspan: "7",
  class: "left"
}
const _hoisted_29 = ["textContent"]
const _hoisted_30 = {
  colspan: "7",
  class: "left"
}
const _hoisted_31 = ["textContent"]
const _hoisted_32 = {
  colspan: "7",
  class: "left"
}
const _hoisted_33 = ["textContent"]
const _hoisted_34 = {
  colspan: "7",
  class: "left"
}
const _hoisted_35 = ["textContent"]
const _hoisted_36 = ["rowspan"]
const _hoisted_37 = ["rowspan"]
const _hoisted_38 = ["rowspan"]
const _hoisted_39 = ["rowspan"]
const _hoisted_40 = ["rowspan"]
const _hoisted_41 = {
  colspan: "7",
  class: "left"
}
const _hoisted_42 = {
  colspan: "7",
  class: "left"
}
const _hoisted_43 = {
  colspan: "7",
  class: "left"
}
const _hoisted_44 = {
  colspan: "7",
  class: "left"
}
const _hoisted_45 = {
  colspan: "7",
  class: "left"
}
const _hoisted_46 = {
  colspan: "7",
  class: "left"
}
const _hoisted_47 = {
  colspan: "7",
  class: "left"
}
const _hoisted_48 = {
  colspan: "7",
  class: "left"
}
const _hoisted_49 = {
  colspan: "7",
  class: "left"
}
const _hoisted_50 = { style: {"height":"auto","width":"100%","margin-bottom":"5px"} }
const _hoisted_51 = { class: "noPrint" }
const _hoisted_52 = {
  colspan: "7",
  class: "left"
}
const _hoisted_53 = { class: "textarea_wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Left = _resolveComponent("Left")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_ModalDefault = _resolveComponent("ModalDefault")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createVNode(_component_Left),
    _createElementVNode("section", {
      class: _normalizeClass(["container", { pdfMode: $setup.isPdfMode }]),
      id: "pdfArea"
    }, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _cache[14] || (_cache[14] = _createElementVNode("p", null, "개별지원통합카드", -1)),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.downloadPdf && $setup.downloadPdf(...args)))
            }, _cache[11] || (_cache[11] = [
              _createElementVNode("img", { src: "img/print.png" }, null, -1),
              _createElementVNode("span", null, "PDF 출력", -1)
            ])),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.downloadExcel && $setup.downloadExcel(...args)))
            }, _cache[12] || (_cache[12] = [
              _createElementVNode("img", { src: "img/excel.png" }, null, -1),
              _createElementVNode("span", null, "Excel 다운", -1)
            ])),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.router.push({ name: 'clientDetail', params: { id: $setup.state.idx } })))
            }, _cache[13] || (_cache[13] = [
              _createElementVNode("span", null, "기초기록으로 연계", -1)
            ]))
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[16] || (_cache[16] = _createElementVNode("label", null, "기간설정", -1)),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    id: "startDate",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.state.startDate) = $event)),
                    onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.changeStartDate && $setup.changeStartDate(...args)))
                  }, null, 544), [
                    [_vModelText, $setup.state.startDate]
                  ])
                ]),
                _cache[15] || (_cache[15] = _createElementVNode("span", null, "~", -1)),
                _createElementVNode("div", _hoisted_8, [
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    id: "endDate",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.state.endDate) = $event)),
                    onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => ($setup.changeEndDate && $setup.changeEndDate(...args)))
                  }, null, 544), [
                    [_vModelText, $setup.state.endDate]
                  ])
                ])
              ])
            ]),
            _createElementVNode("table", _hoisted_9, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", _hoisted_10, [
                  _cache[17] || (_cache[17] = _createElementVNode("th", { class: "second_th" }, [
                    _createElementVNode("b", null, "연번")
                  ], -1)),
                  _createElementVNode("td", _hoisted_11, [
                    _createElementVNode("p", {
                      textContent: _toDisplayString($setup.state.data.client.number)
                    }, null, 8, _hoisted_12)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_13, [
                  _cache[18] || (_cache[18] = _createElementVNode("th", { class: "second_th" }, [
                    _createElementVNode("b", null, "작성일")
                  ], -1)),
                  _createElementVNode("td", _hoisted_14, [
                    _createElementVNode("p", {
                      textContent: _toDisplayString($setup.state.writeDate)
                    }, null, 8, _hoisted_15)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_16, [
                  _cache[20] || (_cache[20] = _createElementVNode("th", { class: "second_th" }, [
                    _createElementVNode("b", null, "작성자")
                  ], -1)),
                  _createElementVNode("td", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("p", {
                        textContent: _toDisplayString($setup.state.writer)
                      }, null, 8, _hoisted_19),
                      _cache[19] || (_cache[19] = _createElementVNode("span", { class: "onlyPrint" }, "(서명)", -1))
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("table", _hoisted_20, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", _hoisted_21, [
                _cache[21] || (_cache[21] = _createElementVNode("th", {
                  rowspan: "3",
                  class: "first_th"
                }, [
                  _createElementVNode("b", null, "기초자료")
                ], -1)),
                _cache[22] || (_cache[22] = _createElementVNode("th", { class: "second_th" }, [
                  _createElementVNode("b", null, "연번")
                ], -1)),
                _createElementVNode("td", _hoisted_22, [
                  _createElementVNode("p", {
                    textContent: _toDisplayString($setup.state.data.client.number)
                  }, null, 8, _hoisted_23)
                ])
              ]),
              _createElementVNode("tr", _hoisted_24, [
                _cache[23] || (_cache[23] = _createElementVNode("th", { class: "second_th" }, [
                  _createElementVNode("b", null, "작성일")
                ], -1)),
                _createElementVNode("td", _hoisted_25, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.state.writeDate) = $event)),
                    type: "text"
                  }, null, 512), [
                    [_vModelText, $setup.state.writeDate]
                  ])
                ])
              ]),
              _createElementVNode("tr", _hoisted_26, [
                _cache[24] || (_cache[24] = _createElementVNode("th", { class: "second_th" }, [
                  _createElementVNode("b", null, "작성자")
                ], -1)),
                _createElementVNode("td", _hoisted_27, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.state.writer) = $event)),
                    type: "text"
                  }, null, 512), [
                    [_vModelText, $setup.state.writer]
                  ])
                ])
              ]),
              _createElementVNode("tr", null, [
                _cache[25] || (_cache[25] = _createElementVNode("th", {
                  rowspan: "4",
                  class: "first_th"
                }, "인적사항", -1)),
                _cache[26] || (_cache[26] = _createElementVNode("th", { class: "second_th gray_th" }, "성명", -1)),
                _createElementVNode("td", _hoisted_28, [
                  _createElementVNode("p", {
                    textContent: _toDisplayString($setup.state.data.client.name)
                  }, null, 8, _hoisted_29)
                ])
              ]),
              _createElementVNode("tr", null, [
                _cache[27] || (_cache[27] = _createElementVNode("th", { class: "second_th gray_th" }, "주민등록번호", -1)),
                _createElementVNode("td", _hoisted_30, [
                  _createElementVNode("p", {
                    textContent: _toDisplayString($setup.CommonUtils.convertJumin($setup.state.data.client.clientDetailVO.jumin))
                  }, null, 8, _hoisted_31)
                ])
              ]),
              _createElementVNode("tr", null, [
                _cache[28] || (_cache[28] = _createElementVNode("th", { class: "second_th gray_th" }, "연락처", -1)),
                _createElementVNode("td", _hoisted_32, [
                  _createElementVNode("p", {
                    textContent: _toDisplayString($setup.CommonUtils.convertPhoneNum($setup.state.data.client.clientDetailVO.phone))
                  }, null, 8, _hoisted_33)
                ])
              ]),
              _createElementVNode("tr", null, [
                _cache[29] || (_cache[29] = _createElementVNode("th", { class: "second_th gray_th" }, "주소", -1)),
                _createElementVNode("td", _hoisted_34, [
                  _createElementVNode("p", {
                    textContent: _toDisplayString($setup.state.data.client.clientDetailVO.address)
                  }, null, 8, _hoisted_35)
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.medicalChunks, (group, gIdx) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: gIdx }, [
                  _createElementVNode("tr", null, [
                    (gIdx == 0)
                      ? (_openBlock(), _createElementBlock("th", {
                          key: 0,
                          rowspan: $setup.medicalChunks.length * 5
                        }, "의료지원", 8, _hoisted_36))
                      : _createCommentVNode("", true),
                    _cache[30] || (_cache[30] = _createElementVNode("th", { class: "second_th gray_th" }, "번호", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (item, idx) => {
                      return (_openBlock(), _createElementBlock("td", { key: idx }, _toDisplayString(idx + 1 + gIdx * 6), 1))
                    }), 128)),
                    _cache[31] || (_cache[31] = _createElementVNode("td", null, "비고", -1))
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[32] || (_cache[32] = _createElementVNode("th", { class: "second_th gray_th" }, "일시", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (item, idx) => {
                      return (_openBlock(), _createElementBlock("td", { key: idx }, [
                        (item.coIdx)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: { name: 'counselDetail', params: { id: item.clIdx, idx: item.coIdx } },
                              target: "_blank"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString($setup.CommonUtils.dateFormatYYYYMMDD(item.date, ".")), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128)),
                    _cache[33] || (_cache[33] = _createElementVNode("td", null, null, -1))
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[34] || (_cache[34] = _createElementVNode("th", { class: "second_th gray_th" }, "금액(원)", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (item, idx) => {
                      return (_openBlock(), _createElementBlock("td", { key: idx }, [
                        (item.coIdx)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: { name: 'counselDetail', params: { id: item.clIdx, idx: item.coIdx } },
                              target: "_blank"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.price ? $setup.CommonUtils.numberFormat(item.price + "".replaceAll(",", "")) : ""), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128)),
                    _cache[35] || (_cache[35] = _createElementVNode("td", null, null, -1))
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[36] || (_cache[36] = _createElementVNode("th", { class: "second_th gray_th" }, "진료과목", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (item, idx) => {
                      return (_openBlock(), _createElementBlock("td", { key: idx }, [
                        (item.coIdx)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: { name: 'counselDetail', params: { id: item.clIdx, idx: item.coIdx } },
                              target: "_blank"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.method && item.method.indexOf("기타") > -1 ? "기타" : item.method), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128)),
                    _cache[37] || (_cache[37] = _createElementVNode("td", null, null, -1))
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[39] || (_cache[39] = _createElementVNode("th", { class: "second_th gray_th" }, "지원시설", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (item, idx) => {
                      return (_openBlock(), _createElementBlock("td", { key: idx }, [
                        (item.coIdx)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: { name: 'counselDetail', params: { id: item.clIdx, idx: item.coIdx } },
                              target: "_blank"
                            }, {
                              default: _withCtx(() => _cache[38] || (_cache[38] = [
                                _createTextVNode(" 다시함께센터 ", -1)
                              ])),
                              _: 2,
                              __: [38]
                            }, 1032, ["to"]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128)),
                    _cache[40] || (_cache[40] = _createElementVNode("td", null, null, -1))
                  ])
                ], 64))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.lawChunks, (group, gIdx) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: gIdx }, [
                  _createElementVNode("tr", null, [
                    (gIdx == 0)
                      ? (_openBlock(), _createElementBlock("th", {
                          key: 0,
                          rowspan: $setup.lawChunks.length * 5
                        }, "법률지원", 8, _hoisted_37))
                      : _createCommentVNode("", true),
                    _cache[41] || (_cache[41] = _createElementVNode("th", { class: "second_th gray_th" }, "번호", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (item, idx) => {
                      return (_openBlock(), _createElementBlock("td", { key: idx }, _toDisplayString(idx + 1 + gIdx * 6), 1))
                    }), 128)),
                    _cache[42] || (_cache[42] = _createElementVNode("td", null, "비고", -1))
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[43] || (_cache[43] = _createElementVNode("th", { class: "second_th gray_th" }, "일시", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (item, idx) => {
                      return (_openBlock(), _createElementBlock("td", { key: idx }, [
                        (item.coIdx)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: { name: 'counselDetail', params: { id: item.clIdx, idx: item.coIdx } },
                              target: "_blank"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString($setup.CommonUtils.dateFormatYYYYMMDD(item.date, ".")), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128)),
                    _cache[44] || (_cache[44] = _createElementVNode("td", null, null, -1))
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[45] || (_cache[45] = _createElementVNode("th", { class: "second_th gray_th" }, "금액(원)", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (item, idx) => {
                      return (_openBlock(), _createElementBlock("td", { key: idx }, [
                        (item.coIdx)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: { name: 'counselDetail', params: { id: item.clIdx, idx: item.coIdx } },
                              target: "_blank"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.price ? $setup.CommonUtils.numberFormat(item.price + "".replaceAll(",", "")) : ""), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128)),
                    _cache[46] || (_cache[46] = _createElementVNode("td", null, null, -1))
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[47] || (_cache[47] = _createElementVNode("th", { class: "second_th gray_th" }, "진료과목", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (item, idx) => {
                      return (_openBlock(), _createElementBlock("td", { key: idx }, [
                        (item.coIdx)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: { name: 'counselDetail', params: { id: item.clIdx, idx: item.coIdx } },
                              target: "_blank"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.method && item.method.indexOf("기타") > -1 ? "기타" : item.method), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128)),
                    _cache[48] || (_cache[48] = _createElementVNode("td", null, null, -1))
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[50] || (_cache[50] = _createElementVNode("th", { class: "second_th gray_th" }, "지원시설", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (item, idx) => {
                      return (_openBlock(), _createElementBlock("td", { key: idx }, [
                        (item.coIdx)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: { name: 'counselDetail', params: { id: item.clIdx, idx: item.coIdx } },
                              target: "_blank"
                            }, {
                              default: _withCtx(() => _cache[49] || (_cache[49] = [
                                _createTextVNode(" 다시함께센터 ", -1)
                              ])),
                              _: 2,
                              __: [49]
                            }, 1032, ["to"]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128)),
                    _cache[51] || (_cache[51] = _createElementVNode("td", null, null, -1))
                  ])
                ], 64))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.vocationalTrainingChunks, (group, gIdx) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: gIdx }, [
                  _createElementVNode("tr", null, [
                    (gIdx == 0)
                      ? (_openBlock(), _createElementBlock("th", {
                          key: 0,
                          rowspan: $setup.vocationalTrainingChunks.length * 5
                        }, "직업훈련지원", 8, _hoisted_38))
                      : _createCommentVNode("", true),
                    _cache[52] || (_cache[52] = _createElementVNode("th", { class: "second_th gray_th" }, "번호", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (item, idx) => {
                      return (_openBlock(), _createElementBlock("td", { key: idx }, _toDisplayString(idx + 1 + gIdx * 6), 1))
                    }), 128)),
                    _cache[53] || (_cache[53] = _createElementVNode("td", null, "비고", -1))
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[54] || (_cache[54] = _createElementVNode("th", { class: "second_th gray_th" }, "일시", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (item, idx) => {
                      return (_openBlock(), _createElementBlock("td", { key: idx }, [
                        (item.coIdx)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: { name: 'counselDetail', params: { id: item.clIdx, idx: item.coIdx } },
                              target: "_blank"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString($setup.CommonUtils.dateFormatYYYYMMDD(item.date, ".")), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128)),
                    _cache[55] || (_cache[55] = _createElementVNode("td", null, null, -1))
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[56] || (_cache[56] = _createElementVNode("th", { class: "second_th gray_th" }, "금액(원)", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (item, idx) => {
                      return (_openBlock(), _createElementBlock("td", { key: idx }, [
                        (item.coIdx)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: { name: 'counselDetail', params: { id: item.clIdx, idx: item.coIdx } },
                              target: "_blank"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.price ? $setup.CommonUtils.numberFormat(item.price + "".replaceAll(",", "")) : ""), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128)),
                    _cache[57] || (_cache[57] = _createElementVNode("td", null, null, -1))
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[58] || (_cache[58] = _createElementVNode("th", { class: "second_th gray_th" }, "진료과목", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (item, idx) => {
                      return (_openBlock(), _createElementBlock("td", { key: idx }, [
                        (item.coIdx)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: { name: 'counselDetail', params: { id: item.clIdx, idx: item.coIdx } },
                              target: "_blank"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.method && item.method.indexOf("기타") > -1 ? "기타" : item.method), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128)),
                    _cache[59] || (_cache[59] = _createElementVNode("td", null, null, -1))
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[61] || (_cache[61] = _createElementVNode("th", { class: "second_th gray_th" }, "지원시설", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (item, idx) => {
                      return (_openBlock(), _createElementBlock("td", { key: idx }, [
                        (item.coIdx)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: { name: 'counselDetail', params: { id: item.clIdx, idx: item.coIdx } },
                              target: "_blank"
                            }, {
                              default: _withCtx(() => _cache[60] || (_cache[60] = [
                                _createTextVNode(" 다시함께센터 ", -1)
                              ])),
                              _: 2,
                              __: [60]
                            }, 1032, ["to"]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128)),
                    _cache[62] || (_cache[62] = _createElementVNode("td", null, null, -1))
                  ])
                ], 64))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.mindChunks, (group, gIdx) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: gIdx }, [
                  _createElementVNode("tr", null, [
                    (gIdx == 0)
                      ? (_openBlock(), _createElementBlock("th", {
                          key: 0,
                          rowspan: $setup.mindChunks.length * 5
                        }, "심리지원", 8, _hoisted_39))
                      : _createCommentVNode("", true),
                    _cache[63] || (_cache[63] = _createElementVNode("th", { class: "second_th gray_th" }, "번호", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (item, idx) => {
                      return (_openBlock(), _createElementBlock("td", { key: idx }, _toDisplayString(idx + 1 + gIdx * 6), 1))
                    }), 128)),
                    _cache[64] || (_cache[64] = _createElementVNode("td", null, "비고", -1))
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[65] || (_cache[65] = _createElementVNode("th", { class: "second_th gray_th" }, "일시", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (item, idx) => {
                      return (_openBlock(), _createElementBlock("td", { key: idx }, [
                        (item.coIdx)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: { name: 'counselDetail', params: { id: item.clIdx, idx: item.coIdx } },
                              target: "_blank"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString($setup.CommonUtils.dateFormatYYYYMMDD(item.date, ".")), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128)),
                    _cache[66] || (_cache[66] = _createElementVNode("td", null, null, -1))
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[67] || (_cache[67] = _createElementVNode("th", { class: "second_th gray_th" }, "금액(원)", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (item, idx) => {
                      return (_openBlock(), _createElementBlock("td", { key: idx }, [
                        (item.coIdx)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: { name: 'counselDetail', params: { id: item.clIdx, idx: item.coIdx } },
                              target: "_blank"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.price ? $setup.CommonUtils.numberFormat(item.price + "".replaceAll(",", "")) : ""), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128)),
                    _cache[68] || (_cache[68] = _createElementVNode("td", null, null, -1))
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[69] || (_cache[69] = _createElementVNode("th", { class: "second_th gray_th" }, "진료과목", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (item, idx) => {
                      return (_openBlock(), _createElementBlock("td", { key: idx }, [
                        (item.coIdx)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: { name: 'counselDetail', params: { id: item.clIdx, idx: item.coIdx } },
                              target: "_blank"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.method && item.method.indexOf("기타") > -1 ? "기타" : item.method), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128)),
                    _cache[70] || (_cache[70] = _createElementVNode("td", null, null, -1))
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[72] || (_cache[72] = _createElementVNode("th", { class: "second_th gray_th" }, "지원시설", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (item, idx) => {
                      return (_openBlock(), _createElementBlock("td", { key: idx }, [
                        (item.coIdx)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: { name: 'counselDetail', params: { id: item.clIdx, idx: item.coIdx } },
                              target: "_blank"
                            }, {
                              default: _withCtx(() => _cache[71] || (_cache[71] = [
                                _createTextVNode(" 다시함께센터 ", -1)
                              ])),
                              _: 2,
                              __: [71]
                            }, 1032, ["to"]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128)),
                    _cache[73] || (_cache[73] = _createElementVNode("td", null, null, -1))
                  ])
                ], 64))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.suppotChunks, (group, gIdx) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: gIdx }, [
                  _createElementVNode("tr", null, [
                    (gIdx == 0)
                      ? (_openBlock(), _createElementBlock("th", {
                          key: 0,
                          rowspan: $setup.suppotChunks.length * 5
                        }, "구조지원비증액", 8, _hoisted_40))
                      : _createCommentVNode("", true),
                    _cache[74] || (_cache[74] = _createElementVNode("th", { class: "second_th gray_th" }, "번호", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (item, idx) => {
                      return (_openBlock(), _createElementBlock("td", { key: idx }, _toDisplayString(idx + 1 + gIdx * 6), 1))
                    }), 128)),
                    _cache[75] || (_cache[75] = _createElementVNode("td", null, "비고", -1))
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[76] || (_cache[76] = _createElementVNode("th", { class: "second_th gray_th" }, "일시", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (item, idx) => {
                      return (_openBlock(), _createElementBlock("td", { key: idx }, [
                        (item.coIdx)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: { name: 'counselDetail', params: { id: item.clIdx, idx: item.coIdx } },
                              target: "_blank"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString($setup.CommonUtils.dateFormatYYYYMMDD(item.date, ".")), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128)),
                    _cache[77] || (_cache[77] = _createElementVNode("td", null, null, -1))
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[78] || (_cache[78] = _createElementVNode("th", { class: "second_th gray_th" }, "금액(원)", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (item, idx) => {
                      return (_openBlock(), _createElementBlock("td", { key: idx }, [
                        (item.coIdx)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: { name: 'counselDetail', params: { id: item.clIdx, idx: item.coIdx } },
                              target: "_blank"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.price ? $setup.CommonUtils.numberFormat(item.price + "".replaceAll(",", "")) : ""), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128)),
                    _cache[79] || (_cache[79] = _createElementVNode("td", null, null, -1))
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[80] || (_cache[80] = _createElementVNode("th", { class: "second_th gray_th" }, "진료과목", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (item, idx) => {
                      return (_openBlock(), _createElementBlock("td", { key: idx }, [
                        (item.coIdx)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: { name: 'counselDetail', params: { id: item.clIdx, idx: item.coIdx } },
                              target: "_blank"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.method && item.method.indexOf("기타") > -1 ? "기타" : item.method), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128)),
                    _cache[81] || (_cache[81] = _createElementVNode("td", null, null, -1))
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[82] || (_cache[82] = _createElementVNode("th", { class: "second_th gray_th" }, "지원시설", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (item, idx) => {
                      return (_openBlock(), _createElementBlock("td", { key: idx }))
                    }), 128)),
                    _cache[83] || (_cache[83] = _createElementVNode("td", null, null, -1))
                  ])
                ], 64))
              }), 128)),
              _createElementVNode("tr", null, [
                _cache[84] || (_cache[84] = _createElementVNode("th", {
                  rowspan: "10",
                  class: "first_th"
                }, [
                  _createElementVNode("b", null, "특이사항")
                ], -1)),
                _cache[85] || (_cache[85] = _createElementVNode("th", { class: "second_th" }, "의료지원 합계", -1)),
                _createElementVNode("td", _hoisted_41, _toDisplayString($setup.CommonUtils.numberFormat($setup.state.summary.medical)), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[86] || (_cache[86] = _createElementVNode("th", { class: "second_th" }, "법률지원 합계", -1)),
                _createElementVNode("td", _hoisted_42, _toDisplayString($setup.CommonUtils.numberFormat($setup.state.summary.law)), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[87] || (_cache[87] = _createElementVNode("th", { class: "second_th" }, "직업훈련 합계", -1)),
                _createElementVNode("td", _hoisted_43, _toDisplayString($setup.CommonUtils.numberFormat($setup.state.summary.vocationalTraining)), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[88] || (_cache[88] = _createElementVNode("th", { class: "second_th" }, "심리지원 합계", -1)),
                _createElementVNode("td", _hoisted_44, _toDisplayString($setup.CommonUtils.numberFormat($setup.state.summary.mind)), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[89] || (_cache[89] = _createElementVNode("th", { class: "second_th" }, "구조지원비 증액 합계", -1)),
                _createElementVNode("td", _hoisted_45, _toDisplayString($setup.CommonUtils.numberFormat($setup.state.summary.support + 10000000)) + "원", 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[90] || (_cache[90] = _createElementVNode("th", { class: "second_th" }, "이전지원 총합계", -1)),
                _createElementVNode("td", _hoisted_46, [
                  ($setup.state.data.etc.length > 0 && $setup.state.data.etc[0].newPrevInstitution)
                    ? (_openBlock(), _createBlock(_component_RouterLink, {
                        key: 0,
                        style: {"color":"red"},
                        to: `/counsel/detail/${$setup.state.idx}/${$setup.state.data.etc[0].coIdx}`,
                        target: "_blank"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($setup.CommonUtils.numberFormat($setup.state.data.etc[0].newPrevSupportingExpensePrice)) + " 원 (이전의료지원 비용: " + _toDisplayString($setup.CommonUtils.numberFormat($setup.state.data.etc[0].newPrevMedicalPrice)) + "원, 이전법률지원 비용:" + _toDisplayString($setup.CommonUtils.numberFormat($setup.state.data.etc[0].newPrevLawPrice)) + "원, 이전직업훈련 비용:" + _toDisplayString($setup.CommonUtils.numberFormat($setup.state.data.etc[0].newPrevJobTrainingPrice)) + "원, 이전 미파악 총비용:" + _toDisplayString($setup.CommonUtils.numberFormat($setup.state.data.etc[0].newPrevNotGraspPrice)) + ", 이전기관명 : " + _toDisplayString($setup.state.data.etc[0].newPrevInstitution) + ") ", 1)
                        ]),
                        _: 1
                      }, 8, ["to"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("tr", null, [
                _cache[91] || (_cache[91] = _createElementVNode("th", { class: "second_th" }, "총합계", -1)),
                _createElementVNode("td", _hoisted_47, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.state.summary.medical + $setup.state.summary.law + $setup.state.summary.vocationalTraining + $setup.state.summary.mind,
                                    )) + "원 ", 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[92] || (_cache[92] = _createElementVNode("th", { class: "second_th" }, "잔액", -1)),
                _createElementVNode("td", _hoisted_48, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.state.summary.support +
                                            10000000 -
                                            ($setup.state.data.etc.length > 0 ? $setup.state.data.etc[0].newPrevSupportingExpensePrice : 0) -
                                            ($setup.state.summary.medical + $setup.state.summary.law + $setup.state.summary.vocationalTraining + $setup.state.summary.mind),
                                    )) + "원 ", 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[93] || (_cache[93] = _createElementVNode("th", { class: "second_th" }, "구조지원비 사용 내역", -1)),
                _createElementVNode("td", _hoisted_49, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.data.etcDetail, (item, key) => {
                    return (_openBlock(), _createElementBlock("p", _hoisted_50, " [" + _toDisplayString(item.date) + "] " + _toDisplayString(item.newCounselorDesc), 1))
                  }), 256))
                ])
              ]),
              _createElementVNode("tr", _hoisted_51, [
                _cache[95] || (_cache[95] = _createElementVNode("th", { class: "second_th" }, "기타", -1)),
                _createElementVNode("td", _hoisted_52, [
                  _createElementVNode("div", _hoisted_53, [
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.state.data.client.commentForSupportCard) = $event))
                    }, null, 512), [
                      [_vModelText, $setup.state.data.client.commentForSupportCard]
                    ])
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => ($setup.saveComment && $setup.saveComment(...args)))
                  }, _cache[94] || (_cache[94] = [
                    _createElementVNode("span", null, "저장", -1)
                  ]))
                ])
              ])
            ])
          ])
        ])
      ])
    ], 2),
    ($setup.state.isLoading)
      ? (_openBlock(), _createBlock(_component_Spinner, {
          key: 0,
          "is-full-page": true
        }))
      : _createCommentVNode("", true),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 1,
          type: $setup.state.modalTab,
          title: $setup.state.modalTitle,
          content: $setup.state.modalContent,
          onClose: $setup.closeModal,
          onCallback: $setup.callBackModal
        }, null, 8, ["type", "title", "content", "onClose", "onCallback"]))
      : _createCommentVNode("", true)
  ], 64))
}